import { combineReducers } from "@reduxjs/toolkit";

import Root from "reducers/RootReducers";

export default combineReducers({
  root: Root,
});
